import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { delay } from 'lodash';

// Import Actions
import {
  requestDeleteOrganization,
} from '../../modules/Admin/AdminActions';

class OrganizationDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.showConfirm,
    };
    this.deleteRequest = this.deleteRequest.bind(this);
    this.close = this.close.bind(this);
    this.handleClick = this.handleClick.bind(this);

    if (props.showConfirm) {
      this.handleClick();
    }

    this.el = typeof document !== 'undefined' ? document.createElement('div') : null;
    this.appRoot = typeof document !== 'undefined' ? document.getElementById('app') || document.body : null;
  }

  componentDidMount() {
    this.mounted = true;
    if (this.appRoot) {
      this.appRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.appRoot) {
      this.appRoot.removeChild(this.el);
    }
    this.el = null;
  }

  /**
   * Dispatch an organization delete request and close the delete organization popup modal
   */
  deleteRequest() {
    const { organization } = this.props;
    this.props.dispatch(requestDeleteOrganization(organization._id))
      .catch((error) => {
        delay(() => {
          this.props.onError(error, { [organization._id]: false });
        }, 100);
      });
    this.close({ [organization._id]: true });
  }

  /**
   * Close the delete organization popup modal
   */
  close(deleting = null) {
    delay(() => {
      this.setState({ show: false });
      this.props.onClose(deleting);
    }, 100);
  }

  handleClick(event) {
    if (event) {
      event.preventDefault();
    }
    this.setState({ show: true });
  }

  renderModal() {
    if (!this.el) {
      return null;
    }

    const { show } = this.state;
    const { organization } = this.props;
    
    const el = (
      <Modal show={show} onHide={this.close}>
        <Modal.Header>
          Delete {organization.display_name}
        </Modal.Header>
        <div>
          <Modal.Body>
            <div className="alert alert-danger">
              <p>
                Are you sure you want to permanently delete the TruVoice Automation instance for {organization.display_name}?
              </p>
              <p>
                Once a client&apos;s TS instance is deleted, this process can not be undone.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-xs-6">
                <div className="clearfix">
                  <Button className="pull-left" bsStyle="link" onClick={this.close}>Cancel</Button>
                </div>
              </div>
              <div className="col-xs-6">
                <div className="clearfix">
                  <Button className="pull-right" bsStyle="danger" onClick={this.deleteRequest}>Yes, Delete {organization.display_name}</Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    );
    return ReactDOM.createPortal(el, this.el);
  }

  render() {
    return (
      <span>
        {this.renderModal()}
      </span>
    );
  }
}

OrganizationDelete.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
  }).isRequired,
  showConfirm: PropTypes.bool,
  onClose: PropTypes.func,
  onError: PropTypes.func,
};
OrganizationDelete.defaultProps = {
  showConfirm: false,
  onClose: () => {},
  onError: () => {},
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default connect()(OrganizationDelete);
